import React, { useEffect, useState } from 'react'
import { Button, DatePicker, Select, Space, Tag, Tooltip } from 'antd'
import EmptyContent from '../../components/EmptyContent'
import { inject, observer } from 'mobx-react'
import queryString from 'query-string'
import { useHistory, useLocation } from 'react-router-dom'
import { ASSIGNEE_TYPE, ISO_DATE_FORMAT, MM_YYYY } from '../../constants'
import SelectPeoplePopup from '../../components/SelectPeoplePopup/SelectPeoplePopup'
import SelectGroupPopup from '../../components/SelectGroupPopup/SelectGroupPopup'
import { yellowPrimary } from '../../color'
import { BankOutlined, TeamOutlined } from '@ant-design/icons'
import { SelectList } from '../MissionCreatePage/MissionCreatePageStyled'
import { AvatarHasName } from '../../components/Common/Avatar'
import moment from 'moment'
import CheckboxTaskTagPicker from '../../components/Shared/CheckboxTaskTagPicker'
import {
  AssigneeWrapper,
  CheckboxGroup,
  SearchWrapper,
} from './SearchFullStyled'

const { Option } = Select

const SearchFull = props => {
  const {
    taskStore,
    taskLevelList,
    dispatchUserFilter,
    selectPeopleStore,
    isVisibleMissionFullCreateModal,
    isVisibleMissionFullDetailModal,
  } = props

  const {
    selectUserData,
    selectDepartmentData,
    selectGroupData,
    handleOpenSelectGroupPopup,
    assigneePopupType,
  } = selectPeopleStore

  const [leaderList, setLeaderList] = useState([])
  const [handlerList, setHandlerList] = useState([])
  const [combinerList, setCombinerList] = useState([])
  const [isVisibleSelectGroupPopup, setIsVisibleSelectGroupPopup] = useState(
    false
  )
  const [
    isVisibleSelectUserDepartmentPopup,
    setIsVisibleSelectUserDepartmentPopup,
  ] = useState(false)
  const [screenWidth, setScreenWidth] = useState(window.innerWidth)

  useEffect(() => {
    const handleWindowResize = () => setScreenWidth(window.innerWidth)
    window.addEventListener('resize', handleWindowResize)
    return () => window.removeEventListener('resize', handleWindowResize)
  }, [])

  useEffect(() => {
    setLeaderList([
      ...selectUserData[ASSIGNEE_TYPE.LEADER],
      ...selectDepartmentData[ASSIGNEE_TYPE.LEADER],
      ...selectGroupData[ASSIGNEE_TYPE.LEADER],
    ])
    setHandlerList([
      ...selectUserData[ASSIGNEE_TYPE.HANDLER],
      ...selectDepartmentData[ASSIGNEE_TYPE.HANDLER],
      ...selectGroupData[ASSIGNEE_TYPE.HANDLER],
    ])
    setCombinerList([
      ...selectUserData[ASSIGNEE_TYPE.COMBINER],
      ...selectDepartmentData[ASSIGNEE_TYPE.COMBINER],
      ...selectGroupData[ASSIGNEE_TYPE.COMBINER],
    ])
  }, [selectUserData, selectDepartmentData, selectGroupData])

  const { missionQueryParams } = taskStore

  const location = useLocation()
  const history = useHistory()
  const queryStringParse = queryString.parse(location.search, {
    arrayFormat: 'index',
  })

  const onSelectCapGiao = async value => {
    taskStore.setMissionQueryParams({
      ...missionQueryParams,
      id_task_level: value,
    })
    const queryStringStringify = queryString.stringify(
      {
        ...queryStringParse,
        id_task_level: value ? value : null,
      },
      {
        skipNull: true,
        arrayFormat: 'index',
      }
    )
    history.replace(`/mission/full?${queryStringStringify}`)
  }

  const onSelectTienDo = async value => {
    taskStore.setMissionQueryParams({
      ...missionQueryParams,
      tien_do: value,
    })
    const queryStringStringify = queryString.stringify(
      {
        ...queryStringParse,
        tien_do: value ? value : null,
      },
      {
        skipNull: true,
        arrayFormat: 'index',
      }
    )
    history.replace(`/mission/full?${queryStringStringify}`)
  }

  const onChangeFilter = param => paramValue => {
    taskStore.setMissionQueryParams({
      ...missionQueryParams,
      [param]: paramValue,
    })

    const queryStringStringify = queryString.stringify(
      {
        ...queryStringParse,
        [param]: paramValue ? paramValue : null,
      },
      {
        skipNull: true,
        arrayFormat: 'index',
      }
    )
    history.replace(`/mission/full?${queryStringStringify}`)
  }

  const handleSubmitSelect = () => {
    setIsVisibleSelectGroupPopup(false)
    setIsVisibleSelectUserDepartmentPopup(false)
    if (selectGroupData[assigneePopupType].length > 0) {
      dispatchUserFilter({
        type: assigneePopupType,
        value: selectGroupData[assigneePopupType][0].id,
        fullName: selectGroupData[assigneePopupType][0].full_name,
        assigneeType: ASSIGNEE_TYPE.GROUP,
      })
      return
    }
    if (selectUserData[assigneePopupType].length > 0) {
      dispatchUserFilter({
        type: assigneePopupType,
        value: selectUserData[assigneePopupType][0].id,
        fullName: selectUserData[assigneePopupType][0].full_name,
        assigneeType: ASSIGNEE_TYPE.USER,
      })
      return
    }
    if (selectDepartmentData[assigneePopupType].length > 0) {
      dispatchUserFilter({
        type: assigneePopupType,
        value: selectDepartmentData[assigneePopupType][0].id,
        fullName: selectDepartmentData[assigneePopupType][0].full_name,
        assigneeType: ASSIGNEE_TYPE.DEPARTMENT,
      })
      return
    }
    dispatchUserFilter({
      type: assigneePopupType,
      value: null,
      fullName: null,
      assigneeType: ASSIGNEE_TYPE.USER,
    })
  }

  const onChangeMonth = value => {
    taskStore.setMissionQueryParams({
      ...missionQueryParams,
      from_date: value
        ? moment(value).startOf('month').format(ISO_DATE_FORMAT)
        : null,
      to_date: value
        ? moment(value).endOf('month').format(ISO_DATE_FORMAT)
        : null,
    })

    const queryStringStringify = queryString.stringify(
      {
        ...queryStringParse,
        from_date: value
          ? moment(value).startOf('month').format(ISO_DATE_FORMAT)
          : null,
        to_date: value
          ? moment(value).endOf('month').format(ISO_DATE_FORMAT)
          : null,
        all_time: value ? null : 'true',
      },
      {
        skipNull: true,
      }
    )
    history.replace(`/mission/full?${queryStringStringify}`)
  }

  const handleChangeDateBy = value => {
    taskStore.setMissionQueryParams({
      ...missionQueryParams,
      date_by: value,
    })
    const queryStringStringify = queryString.stringify(
      {
        ...queryStringParse,
        date_by: value,
      },
      {
        skipNull: true,
      }
    )
    history.replace(`/mission/full?${queryStringStringify}`)
  }

  return (
    <SearchWrapper>
      <Select value={missionQueryParams.date_by} onChange={handleChangeDateBy}>
        <Option value="DISPLAY_DATE">Lọc theo Tháng hiển thị</Option>
        <Option value="CREATED_DATE">Lọc theo Ngày tạo</Option>
      </Select>

      <DatePicker
        style={{ width: 120 }}
        onChange={onChangeMonth}
        defaultValue={
          !queryStringParse.all_time
            ? (queryStringParse.from_date &&
                moment(queryStringParse.from_date)) ||
              moment()
            : null
        }
        picker="month"
        placeholder={'Chọn tháng'}
        format={MM_YYYY}
      />

      <AssigneeWrapper>
        <div>
          <Space>
            <span>Lãnh đạo giao việc:</span>
            <Tooltip title="Chọn nhóm" color={'#ffc069'}>
              <Button
                icon={<TeamOutlined />}
                style={{ color: yellowPrimary, width: 40 }}
                onClick={() => {
                  setIsVisibleSelectGroupPopup(true)
                  handleOpenSelectGroupPopup(ASSIGNEE_TYPE.LEADER)
                }}
              />
            </Tooltip>
          </Space>

          {!isVisibleMissionFullCreateModal &&
            !isVisibleMissionFullDetailModal && (
              <SelectList>
                <div style={{ marginTop: 12 }}>
                  {leaderList.map(el => (
                    <Tag
                      style={{ marginBottom: 5 }}
                      className={'tag-selected'}
                      color={'blue'}
                      key={el.id}
                      closable
                      onClose={() => {
                        dispatchUserFilter({
                          type: el.permission,
                          value: null,
                          fullName: null,
                          assigneeType: null,
                        })
                        selectPeopleStore.handleRemoveSelect(el)
                      }}>
                      <AvatarHasName
                        imgId={el.image_id}
                        size={22}
                        name={el.full_name}
                        icon={
                          (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                            <BankOutlined />
                          )) ||
                          (el.assignee_type === ASSIGNEE_TYPE.GROUP && (
                            <TeamOutlined />
                          ))
                        }
                      />
                    </Tag>
                  ))}
                </div>
              </SelectList>
            )}
        </div>

        <div>
          <Space>
            <span>Xử lý chính:</span>
            <Tooltip title="Chọn nhóm" color={'#ffc069'}>
              <Button
                icon={<TeamOutlined />}
                style={{ color: yellowPrimary, width: 40 }}
                onClick={() => {
                  setIsVisibleSelectGroupPopup(true)
                  handleOpenSelectGroupPopup(ASSIGNEE_TYPE.HANDLER)
                }}
              />
            </Tooltip>
          </Space>

          {!isVisibleMissionFullCreateModal &&
            !isVisibleMissionFullDetailModal && (
              <SelectList>
                <div style={{ marginTop: 12 }}>
                  {handlerList.map(el => (
                    <Tag
                      className={'tag-selected'}
                      color={'blue'}
                      key={el.id}
                      closable
                      onClose={() => {
                        dispatchUserFilter({
                          type: el.permission,
                          value: null,
                          fullName: null,
                          assigneeType: null,
                        })
                        selectPeopleStore.handleRemoveSelect(el)
                      }}>
                      <AvatarHasName
                        imgId={el.image_id}
                        size={22}
                        name={el.full_name}
                        icon={
                          (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                            <BankOutlined />
                          )) ||
                          (el.assignee_type === ASSIGNEE_TYPE.GROUP && (
                            <TeamOutlined />
                          ))
                        }
                      />
                    </Tag>
                  ))}
                </div>
              </SelectList>
            )}
        </div>

        <div>
          <Space>
            <span>Phối hợp xử lý:</span>
            <Tooltip title="Chọn nhóm" color={'#ffc069'}>
              <Button
                icon={<TeamOutlined />}
                style={{ color: yellowPrimary, width: 40 }}
                onClick={() => {
                  setIsVisibleSelectGroupPopup(true)
                  handleOpenSelectGroupPopup(ASSIGNEE_TYPE.COMBINER)
                }}
              />
            </Tooltip>
          </Space>

          {!isVisibleMissionFullCreateModal &&
            !isVisibleMissionFullDetailModal && (
              <SelectList>
                <div style={{ marginTop: 12 }}>
                  {combinerList.map(el => (
                    <Tag
                      className={'tag-selected'}
                      color={'blue'}
                      key={el.id}
                      closable
                      onClose={() => {
                        dispatchUserFilter({
                          type: el.permission,
                          value: null,
                          fullName: null,
                          assigneeType: null,
                        })
                        selectPeopleStore.handleRemoveSelect(el)
                      }}>
                      <AvatarHasName
                        imgId={el.image_id}
                        size={22}
                        name={el.full_name}
                        icon={
                          (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                            <BankOutlined />
                          )) ||
                          (el.assignee_type === ASSIGNEE_TYPE.GROUP && (
                            <TeamOutlined />
                          ))
                        }
                      />
                    </Tag>
                  ))}
                </div>
              </SelectList>
            )}
        </div>
      </AssigneeWrapper>

      <Select
        placeholder={'Lọc theo tiến độ'}
        allowClear
        defaultValue={queryStringParse.tien_do}
        onChange={onSelectTienDo}>
        <Option value="001">Hoàn thành</Option>
        <Option value="002">Chưa hoàn thành</Option>
      </Select>

      <Select
        notFoundContent={<EmptyContent />}
        defaultValue={queryStringParse.id_task_level}
        placeholder={'Chọn cấp giao nhiệm vụ'}
        allowClear
        onChange={onSelectCapGiao}>
        {taskLevelList?.map(taskLevel => (
          <Option key={taskLevel.id_level} value={taskLevel.id_level}>
            {taskLevel.ten_cap}
          </Option>
        ))}
      </Select>

      <CheckboxGroup>
        <CheckboxTaskTagPicker
          defaultValue={queryStringParse.tag}
          onChangePicker={onChangeFilter('tag')}
        />
      </CheckboxGroup>

      <SelectPeoplePopup
        onlySelectOne
        handleCancelSelectUser={() => {
          setIsVisibleSelectUserDepartmentPopup(false)
        }}
        handleSubmitSelectUser={handleSubmitSelect}
        isVisibleSelectPeoplePopup={isVisibleSelectUserDepartmentPopup}
      />

      <SelectGroupPopup
        onlySelectOne
        groupType={'nhiem_vu'}
        isVisibleSelectGroupPopup={isVisibleSelectGroupPopup}
        handleCancelSelectGroup={() => {
          setIsVisibleSelectGroupPopup(false)
        }}
        handleSubmitSelectGroup={handleSubmitSelect}
      />
    </SearchWrapper>
  )
}

SearchFull.propTypes = {}

export default inject(
  'taskStore',
  'departmentStore',
  'loadingAnimationStore',
  'authenticationStore',
  'selectPeopleStore'
)(observer(SearchFull))
